export const INK_COLORS = ['rgb(0,0,255)', 'rgb(0,0,0)'];
export const CANVAS_TEXT_SIZE = 50;
export const CANVAS_GAP = 30;
